/**
 * スマホ用メニュー用補助（Vanilla JS） ver1.0.0
 * ES6
 *
 * □機能
 *
 * □使い方
 *
 */
export default (APP) => {
  // 変数
  const va = {
    modifier: 'drawerOpen',
    scrollPosition: 0
  }

  // フラグ
  const flag = {
    open: false, // 開く = true
    scrollbarFix: false
  }

  // タグ
  const tag = {
    html: 'html',
    state: '[data-ui-drawer="state"]',
    trigger: '[data-ui-drawer="trigger"]',
    drawer: '[data-ui-drawer="drawer"]',
    overlay: '[data-ui-drawer="overlay"]',
    fixbody: '[data-ui-drawer="fixbody"]'
  }

  // 要素
  const el = {
    scrollable: APP.el.scrolling,
    root: document.documentElement,
    html: APP.el.html,
    state: document.querySelector(tag.state),
    trigger: document.querySelector(tag.trigger),
    drawer: document.querySelector(tag.drawer),
    overlay: document.querySelector(tag.overlay),
    fixbody: document.querySelector(tag.fixbody)
  }

  // 関数
  const fn = {}

  /**
   * [init]
   * 初期化、はじめからチェックされていた場合ドロワーを閉じる
   */
  fn.init = () => {
    if (el.state.checked) {
      fn.closeDrawer()
    }
  }

  /**
   * [updateDrawer]
   * aria-expandedなど各種状態の更新
   */
  fn.updateDrawer = (state) => {
    el.drawer.setAttribute('aria-expanded', state)
    el.trigger.setAttribute('aria-expanded', state)
  }

  /**
   * [checkState]
   * checkboxの状態チェック
   */
  fn.checkState = () => {
    const state = el.state.checked

    if (state) {
      fn.openDrawer()
    } else {
      fn.closeDrawer()
    }
  }

  /**
   * [updateState]
   * checkboxの状態を引数に応じて更新
   * すべてのイベントはこの関数を実行する
   */
  fn.updateState = (value) => {
    const state = value

    if (state === flag.open) {
      console.log('[ui-drawer] 状態が同じです')
      return
    }

    fn.updateDrawer(state)
    flag.open = state // フラグ更新
  }

  /**
   * [activateScrollLock]
   * 背景を固定しドロワー内だけスクロールできるようにする：ON
   */
  fn.activateScrollLock = () => {
    fn.addScrollbarWidth()
    el.html.classList.add(va.modifier)
  }

  /**
   * [deactivateScrollLock]
   * 背景を固定しドロワー内だけスクロールできるようにする：OFF
   */
  fn.deactivateScrollLock = () => {
    fn.removeScrollbarWidth()
    el.html.classList.remove(va.modifier)
  }

  /**
   * [openDrawer]
   * ドロワーのオープン
   */
  fn.openDrawer = () => {
    va.scrollPosition = el.scrollable.scrollTop // スクロール位置の取得

    fn.activateScrollLock()
    el.state.checked = true

    el.fixbody.scrollTop = va.scrollPosition // スクロール位置の設定

    el.fixbody.style.position = 'fixed'
    el.fixbody.style.top = -(va.scrollPosition) + 'px'
    el.fixbody.style.left = '0px'
    el.fixbody.style.right = '0px'
    // el.fixbody.style.width = '100%'

    fn.updateState(true)
  }

  /**
   * [closeDrawer]
   * ドロワーのクローズ
   */
  fn.closeDrawer = () => {
    el.state.checked = false
    fn.updateState(false)
  }

  /**
   * [onTransitionEndDrawer]
   * visibility プロパティーを利用して、トランジションの状態を取得
   */
  fn.onTransitionEndDrawer = event => {
    if (event.target !== el.drawer || event.propertyName !== 'visibility') {
      return
    }
    if (!flag.open) {
      fn.deactivateScrollLock()
      el.fixbody.style.position = ''
      el.fixbody.style.top = ''
      el.fixbody.style.left = ''
      el.fixbody.style.right = ''
      // el.fixbody.style.width = ''
      el.scrollable.scrollTop = va.scrollPosition // スクロール位置の設定
    }
  }

  /**
   * [addScrollbarMargin]
   * スクロールバーのマージンを設定
   */
  fn.addScrollbarMargin = value => {
    const len = el.fixbody.length
    for (let i = 0; i < len; i++) {
      el.fixbody[i].style.marginRight = value
    }
  }

  /**
   * [addScrollbarWidth]
   * スクロールバーの幅を計算し、取得
   */
  fn.addScrollbarWidth = () => {
    const scrollbarWidth = window.innerWidth - el.root.clientWidth
    if (!scrollbarWidth) {
      flag.scrollbarFix = false
      return
    }
    const value = scrollbarWidth + 'px'
    fn.addScrollbarMargin(value)
    flag.scrollbarFix = true
  }

  /**
   * [addScrollbarWidth]
   * スクロールバーの幅リセット
   */
  fn.removeScrollbarWidth = () => {
    if (!flag.scrollbarFix) {
      return
    }
    fn.addScrollbarMargin('')
  }

  el.state.addEventListener('change', fn.checkState, false)
  el.drawer.addEventListener('transitionend', fn.onTransitionEndDrawer, false)
  el.overlay.addEventListener('click', fn.closeDrawer, false)

  fn.init() // 初期化
}
